<template>
  <v-text-field
    dark
    :label="label"
    outline
    single-line
    color="white"
    class="input-black"
    :value="value"
    @input="$emit('input', $event)"
    :type="type"
    :error-messages="errorMessages"
  >

  </v-text-field>
</template>

<script>
export default {
  name: 'InputBlack',
  props: ['value', 'type', 'errorMessages', 'label'],
}
</script>

<style lang="scss">
.input-black{
  .v-input__slot{
    min-height: 44px!important;
  }
  .v-label{
    top: 10px!important;
  }
  input{
    margin-top: 3px!important;
  }
}

</style>
